import { render, staticRenderFns } from "./modele-fichier.vue?vue&type=template&id=436c8491"
import script from "./modele-fichier.vue?vue&type=script&lang=js"
export * from "./modele-fichier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports